import { all, call, put, takeLatest } from 'redux-saga/effects'
import chatApi from 'api/ChatApi'
import { handleError } from 'api/api-utils'
import { GET_INDEX_STATUS, SYNC_INDEX } from './constants'
import {
  getIndexStatus as getIndexStatusAction,
  getIndexStatusError,
  getIndexStatusSuccess,
  syncIndexError,
  syncIndexProgress,
  syncIndexSuccess,
} from './actions'

export function* getIndexStatus() {
  try {
    const status = yield call(chatApi.getIndexStatus)
    yield put(getIndexStatusSuccess({ status }))
  } catch (error) {
    yield put(handleError(error, getIndexStatusError))
  }
}

// One call syncs for at most two minutes; each next call continues where the last one stopped.
export function* syncIndex() {
  try {
    while (true) {
      const { pagesRemaining } = yield call(chatApi.syncIndex)
      if (!pagesRemaining) break
      yield put(syncIndexProgress({ pagesRemaining }))
    }
    yield put(syncIndexSuccess())
    yield put(getIndexStatusAction())
  } catch (error) {
    yield put(handleError(error, syncIndexError))
  }
}

export function* chatDocumentationIndexSaga() {
  yield all([
    takeLatest(GET_INDEX_STATUS, getIndexStatus),
    takeLatest(SYNC_INDEX, syncIndex),
  ])
}

export default chatDocumentationIndexSaga
